import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow jobs and background tasks.
 */
export class JobOperations {
  constructor(private client: BaserowClient) {}
  
  // Job methods will be implemented here
} 